// "Demo iste" CTA'ları tek hedefe gider; ayrı bir demo randevu sözleşmesi
// yok. İletişim formu `topic=demo`yu arka ucun kabul ettiği `sales`
// konusuna eşler (contact.tsx).
export const DEMO_REQUEST_PATH = "/contact?topic=demo";
